import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import ScrollPane from '@/components/ScrollPane';
import { generateTitle } from '@/utils/i18n';
import Hamburger from '@/components/Hamburger';
export default {
  components: {
    ScrollPane: ScrollPane,
    Hamburger: Hamburger
  },
  data: function data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {}
    };
  },
  computed: _objectSpread({
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  }, mapGetters(['sidebar'])),
  watch: {
    $route: function $route() {
      this.addViewTags();
      this.moveToCurrentTag();
    },
    visible: function visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    }
  },
  mounted: function mounted() {
    this.addViewTags();
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('toggleSideBar');
    },
    generateTitle: generateTitle,
    // generateTitle by vue-i18n
    generateRoute: function generateRoute() {
      if (this.$route.name) {
        return this.$route;
      }

      return false;
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path || route.name === this.$route.name;
    },
    addViewTags: function addViewTags() {
      var route = this.generateRoute();

      if (!route) {
        return false;
      }

      this.$store.dispatch('addVisitedViews', route);
    },
    moveToCurrentTag: function moveToCurrentTag() {
      var _this = this;

      var tags = this.$refs.tag;
      this.$nextTick(function () {
        var _iterator = _createForOfIteratorHelper(tags),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var tag = _step.value;

            if (tag.to === _this.$route.path) {
              _this.$refs.scrollPane.moveToTarget(tag.$el);

              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    closeSelectedTag: function closeSelectedTag(view) {
      var _this2 = this;

      this.$store.dispatch('delVisitedViews', view).then(function (views) {
        if (_this2.isActive(view)) {
          var latestView = views.slice(-1)[0];

          if (latestView) {
            _this2.$router.push(latestView.path);
          } else {
            _this2.$router.push('/');
          }
        }
      });
    },
    closeOthersTags: function closeOthersTags() {
      var _this3 = this;

      this.$router.push(this.selectedTag.path);
      this.$store.dispatch('delOthersViews', this.selectedTag).then(function () {
        _this3.moveToCurrentTag();
      });
    },
    closeAllTags: function closeAllTags() {
      this.$store.dispatch('delAllViews');
      this.$router.push('/');
    },
    openMenu: function openMenu(tag, e) {
      this.visible = true;
      this.selectedTag = tag;
      this.left = e.clientX;
      this.top = e.clientY;
    },
    closeMenu: function closeMenu() {
      this.visible = false;
    }
  }
};